export default __webpack_public_path__ + "static/media/shine.3a587ed2.png";